import { styled } from '@mui/system';
import { Palette, Typography } from '@mui/material';

const RootDiv = styled('div')(({ theme }) => ({
  width: '100vw',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100vh',
  position: 'fixed',
  background: ' rgba(0,0,0,0.3)',
  zIndex: 4001,
  top: 0,
  right: 0,
  left: 0,
  color: (theme.palette as Palette).primary.dark,
  '@media (min-width: 900px)': {
    justifyContent: 'center',
  },
}));

const ModalDiv = styled('div')({
  width: '95%',
  maxWidth: '336px',
  height: 'auto',
  backgroundColor: '#FFFFFF',
  borderRadius: '10px',
  border: '1px solid #EAEAEA',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 4002,
  padding: '40px 0',
  marginTop: '83px',
  '@media (min-width: 900px)': {
    marginTop: 0,
  },
});

const ErrorImg = styled('img')({
  width: '38.67px',
  maxWidth: '200px',
  height: 'auto',
  marginBottom: '17px',
});

const ErrorTitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '17px',
  lineHeight: '25.5px',
  textAlign: 'center',
  letterSpacing: '0.15px',
  color: '#414046',
  margin: '0 70px 12px 70px',
});

const ErrorSubtitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '21px',
  textAlign: 'center',
  letterSpacing: '0.15px',
  color: '#414046',
  margin: '0 50px 30px 50px',
  span: {
    color: '#0277BD',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
});

const ErrorButton = styled('div')({
  height: 'auto',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#0A7ABE',
  borderRadius: '100px',
  padding: '9px 31px',
  cursor: 'pointer',
});

const ErrorButtonTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '0.15px',
  color: '#FFFFFF',
});

const LoaderContainer = styled('div')({
  display: 'flex',
  marginBottom: '15px',
});

export {
  RootDiv,
  ModalDiv,
  ErrorImg,
  ErrorTitleTypography,
  ErrorSubtitleTypography,
  ErrorButton,
  ErrorButtonTypography,
  LoaderContainer,
};
